import List from "@/components/list";
import { tableBaseProps } from '@/utils/common.js';
import AddHtml from './addHtml.vue';
const Table = (args) => {
  const { listeners, props } = args;
  const detail = listeners["detail"] || function () { }
  const edit = listeners["edit"] || function () { }

  const Deal = ({ props: { vo } }) => {
    const { row: item } = vo;
    const dealConf = [
      ["icon-steps", "详情", () => detail(item), "codeRule:info"],
      ["icon-edit", "编辑", () => edit(item), "codeRule:update"],
    ]
    return (
      <div class="deal-group">
        {dealConf.map((item) => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>)
  }

  const AccountTableConfig = [
    tableBaseProps("干部级别", "cadreLevelName", "m100"),
    tableBaseProps("培训任务", "trainStr", "m150"),
    tableBaseProps("更新时间", "modifyDate", "220"),
    tableBaseProps("操作人", "userName", "180"),
    {
      label: "操作",
      fixed: "right",
      width: "100",
      render: (vo) => <Deal vo={vo} />,
    },
  ]
  return <List {...args} talbeCols={AccountTableConfig} />;
}
export default Table;
